import React from 'react';
import PropTypes from 'prop-types';
import './_styles_/SortControl.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Constants from '../utils/Constants';
import { sortingParamType } from '../types';
import {
    joinClassNames,
    onActionKey,
} from '../utils';

SortControl.propTypes = {
    sortingKey: PropTypes.string.isRequired,
    sortingParam: sortingParamType.isRequired,
    children: PropTypes.node.isRequired,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
};

SortControl.defaultProps = {
    className: null,
};

function SortControl(props) {
    const {
        sortingParam,
        sortingKey,
        onChange,
        children,
        className,
    } = props;

    const onChangeHandler = () => {
        const newSortingParam = { ...sortingParam };
        if (sortingParam.key === sortingKey) {
            switch (sortingParam.direction) {
                case Constants.SORT_ASC:
                    newSortingParam.direction = Constants.SORT_DESC;
                    break;
                case Constants.SORT_DESC:
                    newSortingParam.direction = Constants.SORT_ASC;
                    break;
                default:
                    throw new Error(`Unknown sorting direction: ${sortingParam.direction}`);
            }
        } else {
            newSortingParam.key = sortingKey;
            newSortingParam.direction = Constants.SORT_ASC;
        }
        onChange(newSortingParam);
    };
    return (
        <div onClick={onChangeHandler} className={joinClassNames('sort-control--container', className)} onKeyUp={onActionKey(onChangeHandler)} role="button" tabIndex={0}>
            {children}
            {sortingParam.key === sortingKey
            && (
                <div className="sort-control--arrow"><FontAwesomeIcon icon={`caret-${sortingParam.direction === Constants.SORT_ASC ? 'up' : 'down'}`} /></div>
            )}
        </div>
    );
}

export default SortControl;
